import type { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { OrgchartEmployeeMembershipFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ColoredTag from 'modules/org_chart/components/ColoredTag'

interface Props {
  employeeTeams: OrgchartEmployeeMembershipFragment[]
}

const Teams: FC<Props> = ({ employeeTeams }) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  if (!employeeTeams || employeeTeams.length === 0) {
    return null
  }

  const teams = employeeTeams.map((membership: OrgchartEmployeeMembershipFragment) => {
    const team = membership.team
    if (!team) {
      return null
    }

    const id = team.id

    const handleClick = () => {
      const route = navigation.employees.teams.id.fullPath({ id })
      navigate(route)
    }

    return (
      <Box key={id} paddingRight="s8" paddingBottom="s8">
        <Box onClick={handleClick} cursor="pointer">
          <ColoredTag>{team.name}</ColoredTag>
        </Box>
      </Box>
    )
  })

  if (!teams.length) return null

  return (
    <Box padding="s24" gap="s16" flexDirection="column">
      <Text.Header2>{i18n.t('employees.orgchart.teams')}</Text.Header2>
      <Box flexDirection="row" alignItems="flexStart" flexWrap="wrap">
        {teams}
      </Box>
    </Box>
  )
}

export default Teams
